import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForm, FormProvider, useFormContext } from 'react-hook-form';
import { Btnone } from '../button';
import { useDispatch } from 'react-redux';
import { postRegisterUser } from '../../../../redux/slices/loginRegister';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import LoaderOverlay from '../../common/LoaderOverlay';
import { useAuth0 } from '@auth0/auth0-react'; // ✅ NEW

const SignupFrom = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginWithRedirect } = useAuth0(); // ✅ NEW

  const schema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email is required'),
    password: Yup.string().required('Password is required').min(6, 'Password must be at least 6 characters'),
    name: Yup.string().required('Username is required'),
    contact: Yup.string()
      .required('Contact number is required')
      .matches(/^\d{10}$/, 'Contact number must be 10 digits'),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: '',
      password: '',
      name: '',
      contact: '',
    },
  });

  const { reset, handleSubmit, formState: { isSubmitting } } = methods;

  const onSubmit = async (data) => {
    try {
      let formData = new FormData();
      formData.set("name", data.name);
      formData.set("contact", data.contact);
      formData.set("email", data.email);
      formData.set("password", data.password);

      const result = await dispatch(postRegisterUser(formData, reset, toast, navigate));

      if (result?.success) {
        setTimeout(() => {
          navigate("/login");
          toast.success("Verification email sent. Please verify your email to login.");
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, 1000);
      }
    } catch (error) {
      console.error("Signup error:", error);
    }
  };

  const scrollToClick = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {isSubmitting && <LoaderOverlay />}
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <UsernameInput />
          <EmailInput />
          <ContactInput />
          <PasswordInput />

          <div className='mt-6'>
            <Btnone
              title="Register now"
              bgColor="#00A762"
              type="submit"
              width="100%"
              loading={isSubmitting}
            />
          </div>

          {/* ✅ Google Signup Button */}
          <div className="mt-6 text-center">
            <button
              type="button"
              onClick={() => loginWithRedirect()}
              className="w-full bg-white border border-gray-300 text-gray-700 py-2 px-4 rounded-md shadow-sm hover:bg-gray-100 transition"
            >
              <img
                src="https://developers.google.com/identity/images/g-logo.png"
                alt="Google"
                className="inline-block w-5 h-5 mr-2 align-middle"
              />
              Sign up with Google
            </button>
          </div>

          <div className='mt-3 flex items-center'>
            <h2 className="text-center font-dm text-base capitalize font-medium">
              You A Member?
              <span
                className='text-[#00A762] ml-2 cursor-pointer'
                onClick={() => scrollToClick('/login')}
              >
                Login
              </span>
            </h2>
          </div>
        </form>
      </FormProvider>
    </>
  );
};

// Inputs
const UsernameInput = () => {
  const { register, formState: { errors } } = useFormContext();
  return (
    <div className='mt-3'>
      <label className='block text-[#072320] font-dm text-lg capitalize font-medium' htmlFor="name">Full Name<span className='font-medium text-red-500'>*</span></label>
      <input className='input_box w-full' type="text" id="name" placeholder='Enter username' {...register('name')} />
      {errors.name && <p className="text-red-500 mt-1">{errors.name.message}</p>}
    </div>
  );
};

const EmailInput = () => {
  const { register, formState: { errors } } = useFormContext();
  return (
    <div className='mt-3'>
      <label className='block text-[#072320] font-dm text-lg capitalize font-medium' htmlFor="email">Email<span className='font-medium text-red-500'>*</span></label>
      <input className='input_box w-full' type="email" id="email" placeholder='Enter email address' {...register('email')} />
      {errors.email && <p className="text-red-500 mt-1">{errors.email.message}</p>}
    </div>
  );
};

const ContactInput = () => {
  const { register, formState: { errors } } = useFormContext();
  return (
    <div className='mt-3'>
      <label className='block text-[#072320] font-dm text-lg capitalize font-medium' htmlFor="contact">Contact Number<span className='font-medium text-red-500'>*</span></label>
      <input className='input_box w-full' type="tel" id="contact" placeholder='Enter contact number' {...register('contact')} />
      {errors.contact && <p className="text-red-500 mt-1">{errors.contact.message}</p>}
    </div>
  );
};

const PasswordInput = () => {
  const { register, formState: { errors } } = useFormContext();
  return (
    <div className='mt-3'>
      <label className='block text-[#072320] font-dm text-lg capitalize font-medium' htmlFor="password">Password<span className='font-medium text-red-500'>*</span></label>
      <input className='input_box w-full' type="password" id="password" placeholder='Password' {...register('password')} />
      {errors.password && <p className="text-red-500 mt-1">{errors.password.message}</p>}
    </div>
  );
};

export default SignupFrom;
